// Used in Report Wizard and Add Dimension Columns popup.
//
// Handles all the enable/disable logic, and the Budget validation.
;delta.reportDimensionColumns = function () {
    var

    _$popup = null,

    //the columns tab link
    _$columnsTabLink = null,

    //our filter checks
    _$filterChecks = null,

    //these each have $check, $label, and $dropdown
    _allOptions = null,
    _current = null,
    _prior = null,
    _budget = null,

    //these each have $group, $check, $dropdown
    _priorVar1 = null,
    _priorVar2 = null,
    _budgetVar1 = null,
    _budgetVar2 = null,
    
    //this has $check and $label
    _includeHeaders = null,


    init = function($popup) {
        //save our popup
        _$popup = $popup;

        //get our elements

        //Note:  we can't get elements by id because they are different depending on if this is used 
        //       by the wizard or add dimension column popup.
        
        //the columns tab link
        _$columnsTabLink = _$popup.find('.modal-body').find('#nav-dimension-columns-tab');        
        
        //all our filter checks, they are named differently for the 2 popups
        _$filterChecks = _$popup.find('.modal-body').find('input[name="DimensionBuilder.Filters"], input[name="DimensionColumns.DimensionBuilder.Filters"]');
        
        //all options - all check/label/dropdowns
        _allOptions = {
            $checks: _$popup.find('.modal-body .dimension-column-options input[type=checkbox]'),
            $labels: _$popup.find('.modal-body .dimension-column-options label'),
            $dropdowns: _$popup.find('.modal-body .dimension-column-options select')
        };
        
        _current = {
            $check: _$popup.find('.modal-body .dimension-column-options .dc-current input[type=checkbox]'),
            $label: _$popup.find('.modal-body .dimension-column-options .dc-current label'),
            $dropdown:  _$popup.find('.modal-body .dimension-column-options .dc-current select')
        };

        _prior = {
            $check: _$popup.find('.modal-body .dimension-column-options .dc-prior input[type=checkbox]'),
            $label: _$popup.find('.modal-body .dimension-column-options .dc-prior label'),
            $dropdown:  _$popup.find('.modal-body .dimension-column-options .dc-prior select')
        };

        _budget = {
            $check: _$popup.find('.modal-body .dimension-column-options .dc-budget input[type=checkbox]'),
            $label: _$popup.find('.modal-body .dimension-column-options .dc-budget label'),
            $dropdown:  _$popup.find('.modal-body .dimension-column-options .dc-budget select')
        };
        
        _priorVar1 = {
            $group: _$popup.find('.modal-body .dimension-column-options .dc-prior-var1'),
            $check:  _$popup.find('.modal-body .dimension-column-options .dc-prior-var1 input[type=checkbox]'),
            $label: _$popup.find('.modal-body .dimension-column-options .dc-prior-var1 label'),
            $dropdown: _$popup.find('.modal-body .dimension-column-options .dc-prior-var1 select')
        };

        _priorVar2 = {
            $group: _$popup.find('.modal-body .dimension-column-options .dc-prior-var2'),
            $check:  _$popup.find('.modal-body .dimension-column-options .dc-prior-var2 input[type=checkbox]'),
            $label: _$popup.find('.modal-body .dimension-column-options .dc-prior-var2 label'),
            $dropdown: _$popup.find('.modal-body .dimension-column-options .dc-prior-var2 select')
        };

        _budgetVar1 = {
            $group: _$popup.find('.modal-body .dimension-column-options .dc-budget-var1'),
            $check:  _$popup.find('.modal-body .dimension-column-options .dc-budget-var1 input[type=checkbox]'),
            $label: _$popup.find('.modal-body .dimension-column-options .dc-budget-var1 label'),
            $dropdown: _$popup.find('.modal-body .dimension-column-options .dc-budget-var1 select')
        };

        _budgetVar2 = {
            $group: _$popup.find('.modal-body .dimension-column-options .dc-budget-var2'),
            $check: _$popup.find('.modal-body .dimension-column-options .dc-budget-var2 input[type=checkbox]'),
            $label: _$popup.find('.modal-body .dimension-column-options .dc-budget-var2 label'),
            $dropdown: _$popup.find('.modal-body .dimension-column-options .dc-budget-var2 select')
        };

        _includeHeaders = {
            $check: _$popup.find('.modal-body .dimension-column-options .dc-include-headings input[type=checkbox]'),
            $label: _$popup.find('.modal-body .dimension-column-options .dc-include-headings label')
        };

        //we need to update the dimension name in the Include a Section Header checkbox.  Since the label
        //is written with asp-for, it can't contain html.  We'll inject a span tag here
        _includeHeaders.$label.html(_includeHeaders.$label.html().replace('Dimension Column', '<span>Dimension Column</span>'));

        //if running from the wizard, changing the dimension column will update the include headers text.  When
        //running from the Add Dimension Columns popup, the hidden field bedlow will have the dimension name, we'll
        //update it here.
        var dimensionName = _$popup.find('#hdnDimensionName').val();
        if (dimensionName) {
            updateIncludeHeadersText(dimensionName);
        }
            

        //reset everything to the starting state
        reset();
        updateUI();

        //check box handlers
        setupCheckHandlers();
    },


    //
    // reset to initial state
    // 
    reset = function() {
        //the options checkboxes are applying opacity=0.5 to the label when the checkbox is disabled.  I don't want this, I'll manage the labels
        //muting manually.
        _allOptions.$labels.css('opacity', 1);

        //uncheck all filters
        _$filterChecks.prop('checked', false);

        //restore dropdown defaults from data-default
        _allOptions.$dropdowns.each(function() {
            var $elem = $(this);
            $elem.val($elem.attr('data-default'));
        });

        //remove any validation errors
        _$popup.find('.modal-body .dimension-column-options').find('.required-label').remove();

        updateUI();
    },


    //
    // add handlers to all checkboxes
    //
    setupCheckHandlers = function() {
        _$filterChecks.click(function() {
            updateUI();
        });

        _allOptions.$checks.click(function() {
            var $chk = $(this);

            //need to handle actual, prior & budget here since they toggle the other one off when checked
            if ($chk.is(':checked')) {
                if (($chk.attr('id').includes('DimensionBuilder_Prior'))) {
                    optionCheckEnable(_budget, false);
                };

                if (($chk.attr('id').includes('DimensionBuilder_Budget'))) {
                    optionCheckEnable(_prior, false);
                };
            }

            updateUI();
        });
    },


    //
    // update the UI based on what's checked
    //
    updateUI = function() {
        //count of filter checks
        filterCheckCount = _$filterChecks.filter(':checked').length;

        //actual, current
        if (filterCheckCount > 0) {
            //columns tab link enabled
            _$columnsTabLink.removeClass('disabled');

            //checkbox is checked and disabled
            _current.$check.prop('checked', true).prop('disabled', true);

            //enable label & dropdown
            _current.$label.removeClass('muted');
            _current.$dropdown.prop('disabled', false);
        } else {
            //columns tab link disabled
            _$columnsTabLink.addClass('disabled');

            //checkbox is unchecked and disabled
            _current.$check.prop('checked', false).prop('disabled', true);

            //disable label & dropdown
            _current.$label.addClass('muted');
            _current.$dropdown.prop('disabled', true);
        }

        //actual prior
        optionCheckEnable(_prior, _current.$check.is(':checked'));
        _prior.$dropdown.prop('disabled', !_prior.$check.is(':checked'));

        //budget
        optionCheckEnable(_budget, _current.$check.is(':checked'));
        _budget.$dropdown.prop('disabled', !_budget.$check.is(':checked'));

        //if budget is checked, show the budget variances controls, otherwise show the prior variance controls
        if (_budget.$check.is(':checked')) {
            //budget checked, show budget var controls
            _budgetVar1.$group.show();
            _budgetVar2.$group.show();

            //hide prior var controls
            _priorVar1.$group.hide();
            _priorVar2.$group.hide();
        } else {
            //budget not checked, hide budget var controls
            _budgetVar1.$group.hide();
            _budgetVar2.$group.hide();

            //show prior var controls
            _priorVar1.$group.show();
            _priorVar2.$group.show();
        }

        //prior var, enable if current & prior checked, otherwise disable then
        if (_current.$check.is(':checked') && _prior.$check.is(':checked')) {
            optionCheckEnable(_priorVar1, true);
            optionCheckEnable(_priorVar2, true);
        } else {
            optionCheckEnable(_priorVar1, false);
            optionCheckEnable(_priorVar2, false);
        }

        //prior var dropdowns, enable if checked
        _priorVar1.$dropdown.prop('disabled', !_priorVar1.$check.is(':checked'));
        _priorVar2.$dropdown.prop('disabled', !_priorVar2.$check.is(':checked'));

        //budget var, enable if current & budget checked, otherwise disable then
        if (_current.$check.is(':checked') && _budget.$check.is(':checked')) {
            optionCheckEnable(_budgetVar1, true);
            optionCheckEnable(_budgetVar2, true);
        } else {
            optionCheckEnable(_budgetVar1, false);
            optionCheckEnable(_budgetVar2, false);
        }

        //budget var dropdowns, enable if checked
        _budgetVar1.$dropdown.prop('disabled', !_budgetVar1.$check.is(':checked'));
        _budgetVar2.$dropdown.prop('disabled', !_budgetVar2.$check.is(':checked'));

        //include section headers
        if (filterCheckCount == 0) {
            //no filters, disable it
            optionCheckEnable(_includeHeaders, false);
        } else {
            //at least one fitler selected, enable it
            optionCheckEnable(_includeHeaders, true);

            // if prior or budget is checked, check include headers & disable it.  If the later uncheck one of those, leave
            // include headers checked but enable it
            if (_prior.$check.is(':checked') || _budget.$check.is(':checked')) {
                _includeHeaders.$check.prop('checked', true).prop('disabled', true);
            } else {
                _includeHeaders.$check.prop('disabled', false);
            }
        }

    },

    //
    // enable/disable an option checkbox & label
    //
    optionCheckEnable = function(item, enable) {
        if (enable) {
            item.$check.prop('disabled', false);
            item.$label.removeClass('muted');
        } else {
            item.$check.prop('disabled', true).prop('checked', false);
            item.$label.addClass('muted');
        }
    },


    //
    // validate, if budget is checked a budget must be selected
    //
    validate = function() {
        //first, remove any validation errors
        _$popup.find('.modal-body .dimension-column-options').find('.required-label').remove();

        if (_budget.$check.is(':checked')) {
            if (_budget.$dropdown.val() == '') {
                //add error message
                _budget.$dropdown.after(`<label class="required-label text-danger mt-1">Please select a Budget</label>`);

                return false;
            }
        }

        //valid if we make it here
        return true;
    },

    
    //
    // update the dimension name in the include section headers text
    //
    updateIncludeHeadersText = function(dimensionName) {
        _includeHeaders.$label.find('span').html(dimensionName);
    },

    //
    // build the Dimension Column summary for the wizard.  Doing it here because we already have 
    // variables for the jquery elems we need
    //
    summary = function() {
        var s = '';

        //each of our main filters that are checked
        _$filterChecks.filter(':checked').each(function() {
            var $chk = $(this);
            var $label = $chk.next('label');
            var indent = (parseInt($chk.attr('data-indent')) + 1) * 20;

            s += `<li style='margin-left:${indent}px'>${$label.html()}</li>`;
        });

        //options
        s += getSummaryOption(_current);
        s += getSummaryOption(_prior);
        s += getSummaryOption(_budget);
        s += getSummaryOption(_priorVar1);
        s += getSummaryOption(_priorVar2);
        s += getSummaryOption(_budgetVar1);
        s += getSummaryOption(_budgetVar2);

        //include section headers
        if (_includeHeaders.$check.is(':checked')) {
            console.log(_includeHeaders.$label.html().replace('?', ''));
            s += `<li style='margin-left:20px;'>${_includeHeaders.$label.html().replace('?', '')}</li>`;
        }
        return s;
    },

    //
    // gets the wizard summary info for a check/dropdown combination
    //
    getSummaryOption = function(option) {
        var s = '';

        if (option.$check.is(':checked')) {
            var selectedOption = option.$dropdown.find('option:selected');

            s += `<li style='margin-left:20px;'>${option.$label.html()}: ${selectedOption.html()}</li>`;
        }
        return s;
    },



    dummy = function() {};

    //return methods
    return {
        init: init,
        reset: reset,
        validate: validate,
        updateIncludeHeadersText: updateIncludeHeadersText,
        summary: summary
    };
}();